import React from "react"
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from "../components/Common/PageBanner"
import CTABanner from "../components/Common/CTABanner"
import Footer from "../components/App/Footer"
import SEO from "../components/App/SEO"

const Privacy = () => {
  return (
    <Layout>
      <SEO
        title="Privacy Policy | Oxygen - Home Loans Made Simple"
        description="This Privacy Policy was Last updated on July 2026 ."
      />
      <Navbar />
      <PageBanner
        // pageTitle=""
        pageSubTitle="This Privacy Policy was Last updated on July 2026 ."
      />
      <section className="privacy-policy-area pb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="privacy-policy-content">
                {/*<p><i>This Privacy Policy was Last updated on July 2026 .</i></p>*/}

                <h3 className="pt-lg-3 pt-md-0">1. Introduction and scope</h3>
                <p>
                  Oxygen Broking Services Pty Ltd (ACN 103 177 377) and its
                  related bodies corporate (including Oxygen Lending Services
                  Pty Ltd and Oxygen Capital Group Pty Ltd), together with
                  Westvalley Corporation Pty Ltd (ABN 48 101 816 586, Australian
                  Credit Licence 365592) trading as Oxygen Home Loans WA, and
                  their franchisees, credit representatives, agents and brokers
                  (Oxygen, we, our, us), respect your privacy and the security
                  of your personal information.
                </p>
                <p className="non-bold">
                  We are bound by the Privacy Act 1988 (Cth) (Privacy Act),
                  including the 13 Australian Privacy Principles (APPs) in
                  Schedule 1 to that Act. Where we handle credit-related
                  information, we are also bound by Part IIIA of the Privacy Act
                  and the Privacy (Credit Reporting) Code (CR Code).
                </p>
                <p className="non-bold">
                  This Privacy Policy explains how we collect, hold, use,
                  disclose and protect your personal information, how you can
                  access and correct it, and how you can make a privacy
                  complaint. It applies to all personal information we handle —
                  whether you are a customer, a website visitor, a broker, agent
                  or franchisee, an employee or contractor, a supplier, a
                  shareholder, or another individual we deal with.
                </p>
                <p className="non-bold">
                  We review this Policy when our information handling practices
                  or the law change, and at least annually. The current version
                  is published at{" "}
                  <a href="https://oxygen.com.au/privacy">
                    oxygen.com.au/privacy
                  </a>{" "}
                  and takes effect when it is published.
                </p>

                <h3>2. Anonymity and pseudonymity</h3>
                <p className="non-bold">
                  Where it is lawful and practicable, you may deal with us
                  anonymously or by using a pseudonym — for example, when you
                  make a general enquiry about our products, services or
                  property listings. It is usually not practicable for us to
                  deal with you anonymously when we provide credit assistance,
                  arrange or manage finance, verify your identity, or meet our
                  legal obligations, because the law requires us to know who you
                  are.
                </p>

                <h3>3. The kinds of personal information we collect</h3>
                <p className="non-bold">
                  Personal information is information or an opinion about an
                  identified individual, or an individual who is reasonably
                  identifiable. The personal information we collect depends on
                  our relationship with you and may include your name, date of
                  birth, gender, contact details (address, email and telephone),
                  employment and income details, assets and liabilities,
                  property details, identification details (such as your driver
                  licence or passport number), and payment or bank account
                  details.
                </p>
                <p className="non-bold">
                  <strong>Credit-related information.</strong> If you apply for
                  or hold finance through us, we collect credit-related
                  information, including credit information and credit
                  eligibility information as those terms are used in Part IIIA
                  of the Privacy Act. This is described in section 7.
                </p>
                <p className="non-bold">
                  <strong>Sensitive information.</strong> Sensitive information
                  including health information, racial or ethnic origin,
                  religious or philosophical beliefs, sexual orientation, and
                  membership of a professional or trade association receives a
                  higher level of protection under the APPs. We collect
                  sensitive information only where you consent and it is
                  reasonably necessary for one or more of our functions or
                  activities, or where the collection is required or authorised
                  by law. If you are an employee or job applicant, we may
                  collect sensitive information relevant to your engagement,
                  such as criminal history for a police check, with your
                  consent.
                </p>
                <p className="non-bold">
                  If you provide sensitive information to us voluntarily, we
                  treat it as personal information and handle it under this
                  Policy.
                </p>
                <p className="non-bold">
                  You do not have to provide us with all the information we
                  request. However, if you do not, we may be unable to provide
                  you with the products, services or information you have
                  requested, or to the standard you expect.
                </p>

                <h3>4. How we collect personal information</h3>
                <p className="non-bold">
                  Where reasonably practicable, we collect personal information
                  directly from you when you enquire about or apply for our
                  products and services, subscribe to our communications, attend
                  an event or property inspection, apply for a role with us, or
                  otherwise interact with us in person, by telephone, online or
                  through our social media pages.
                </p>
                <p className="non-bold">
                  Sometimes we collect personal information about you from other
                  people or organisations, including:
                </p>
                <ul>
                  <li>
                    brokers, credit representatives, franchisees and other
                    companies in the Oxygen group;
                  </li>
                  <li>
                    your representatives, such as your lawyer, accountant,
                    financial adviser, conveyancer or another mortgage broker;
                  </li>
                  <li>credit reporting bodies and other credit providers;</li>
                  <li>your nominated referees and your employer;</li>
                  <li>identity verification providers;</li>
                  <li>government agencies and law enforcement bodies; and</li>
                  <li>
                    providers of marketing, data-analytics, survey and
                    event-management services.
                  </li>
                </ul>
                <p className="non-bold">
                  Where we collect your personal information from a third party,
                  we take reasonable steps to be satisfied that you have
                  consented to that collection or would reasonably expect us to
                  collect it in that way.
                </p>
                <p className="non-bold">
                  When we collect your personal information, we take reasonable
                  steps to notify you, or make sure you are aware, of the
                  matters required by APP 5 including who we are, why we are
                  collecting the information, the types of parties we usually
                  disclose it to, and how you can access it, seek correction, or
                  make a complaint. This Policy forms part of that notice.
                </p>
                <p className="non-bold">
                  <strong>Unsolicited information.</strong> If we receive
                  personal information we did not ask for, we decide whether we
                  could have collected it under APP 3. If we could not, and the
                  information is not contained in a Commonwealth record, we
                  destroy or de-identify it as soon as practicable, where it is
                  lawful and reasonable to do so.
                </p>

                <h3>
                  5. Why we collect, hold, use and disclose your personal
                  information
                </h3>
                <p className="non-bold">
                  We collect, hold, use and disclose your personal information
                  to carry out our functions and activities, including to:
                </p>
                <ul>
                  <li>
                    assess and process applications for finance or mortgage
                    insurance, provide credit assistance, and arrange and manage
                    that finance;
                  </li>
                  <li>
                    verify your identity and conduct credit and other checks;
                  </li>
                  <li>
                    provide, administer and improve our products, services and
                    websites, and respond to your enquiries, feedback and
                    complaints;
                  </li>
                  <li>
                    market properties and facilitate sales and leasing
                    transactions, and provide property concierge services, for
                    the Oxygen group&apos;s real-estate functions;
                  </li>
                  <li>
                    plan and run our conferences, training and events, including
                    recording continuing professional development;
                  </li>
                  <li>carry out marketing and research (see section 8);</li>
                  <li>
                    manage our people, contractors, brokers and franchisees,
                    including assessing suitability for appointment;
                  </li>
                  <li>
                    maintain any register of shareholders in Oxygen Limited
                    under the Corporations Act 2001 (Cth); and
                  </li>
                  <li>
                    keep records and meet our legal and regulatory obligations.
                  </li>
                </ul>
                <p className="non-bold">
                  We use and disclose your personal information for the purpose
                  for which we collected it (the primary purpose), for a related
                  purpose you would reasonably expect, where you have consented,
                  or where the use or disclosure is otherwise permitted under
                  APP 6, for example, where it is required or authorised by law.
                </p>

                <h3>6. Disclosure of personal information</h3>
                <p className="non-bold">
                  We may disclose your personal information to:
                </p>
                <ul>
                  <li>
                    our officers, employees, credit representatives, agents,
                    brokers, contractors and franchisees, and other companies in
                    the Oxygen group;
                  </li>
                  <li>
                    lenders, credit providers, mortgage intermediaries,
                    aggregators, insurers, valuers and guarantors involved in
                    your finance;
                  </li>
                  <li>
                    credit reporting bodies and other credit providers (see
                    section 7);
                  </li>
                  <li>
                    your authorised representatives, and, for property
                    transactions, the other parties to the transaction and their
                    representatives;
                  </li>
                  <li>
                    our suppliers and service providers — including providers of
                    IT, data hosting and back-up, mailing and printing, payment
                    processing, marketing and digital marketing, data analytics,
                    market research, event management, recruitment, payroll and
                    share-registry services;
                  </li>
                  <li>
                    regulators, government agencies, courts and law enforcement
                    bodies; and
                  </li>
                  <li>
                    a party considering acquiring an interest in our business,
                    and any person to whom we are required or authorised by law
                    to disclose it.
                  </li>
                </ul>
                <p className="non-bold">
                  We require the third parties to whom we disclose personal
                  information, or who have access to it, to have appropriate
                  controls to protect it consistent with this Policy and the
                  APPs, and to use it only for the authorised purpose.
                </p>

                <h3>7. Credit-related information</h3>
                <p className="non-bold">
                  If you apply for or hold consumer credit through us, we handle
                  credit-related information under Part IIIA of the Privacy Act
                  and the CR Code, in addition to the APPs.
                </p>
                <p className="non-bold">
                  The credit information we collect, and hold may include your
                  identification details; the type, terms and maximum amount of
                  credit you have applied for or hold; repayment history
                  information; default and payment information; new-arrangement
                  and financial-hardship information; court and
                  personal-insolvency information; and information about serious
                  credit infringements.
                </p>
                <p className="non-bold">
                  We may disclose your credit information to, and collect credit
                  reporting information about you from, credit reporting bodies.
                  A credit reporting body may include information we give it in
                  reports it provides to other credit providers to help them
                  assess your creditworthiness.
                </p>
                <p className="non-bold">
                  The credit reporting body/bodies we use, and how to obtain
                  each body&apos;s credit reporting policy, are set out at:
                  [insert credit reporting body name(s) and link(s) before
                  publishing — for example Equifax, illion or Experian].
                </p>
                <p className="non-bold">You have the right to:</p>
                <ul>
                  <li>
                    ask a credit reporting body for a copy of its policy on the
                    management of credit-related personal information;
                  </li>
                  <li>
                    ask a credit reporting body not to use or disclose your
                    credit reporting information to decide whether to send you
                    direct marketing (pre-screening) of credit offers; and
                  </li>
                  <li>
                    ask a credit reporting body not to use or disclose your
                    credit reporting information if you believe you have been,
                    or are likely to be, a victim of fraud (a ban period).
                  </li>
                </ul>
                <p className="non-bold">
                  If you have a complaint about how we have handled your credit
                  information, see section 17.
                </p>

                <h3>8. Direct marketing</h3>
                <p className="non-bold">
                  From time to time we may send you direct marketing about our
                  products, services, property listings, events and other
                  material we think may interest you. If you do not want to
                  receive it, you can opt out at any time. Every marketing email
                  contains an unsubscribe mechanism; to stop other marketing
                  communications, contact us using the details in section 18.
                </p>
                <p className="non-bold">
                  If you opt out of direct marketing, we may still contact you
                  for other reasonable purposes, including information we are
                  legally required to send and notifications about changes to
                  our products, services or policies. We do not use or disclose
                  sensitive information for direct marketing without your
                  consent, and you can ask a credit reporting body not to use
                  your credit reporting information for pre-screening (see
                  section 7).
                </p>

                <h3>9. Cross-border disclosure of personal information</h3>
                <p className="non-bold">
                  Some of the service providers and other parties we disclose
                  personal information to are located, or store data, outside
                  Australia. Before we disclose your personal information to an
                  overseas recipient, we take reasonable steps to ensure the
                  recipient does not breach the APPs in relation to that
                  information, unless an exception in APP 8 applies.
                </p>
                <p className="non-bold">
                  Based on our current arrangements, the countries in which
                  overseas recipients are located, or in which your information
                  may be stored, include the United States, countries in Europe,
                  and Japan.
                </p>

                <h3>10. Government related identifiers</h3>
                <p className="non-bold">
                  We do not adopt a government related identifier of yours such
                  as a tax file number, Medicare number or driver licence number
                  as our own identifier of you. We use or disclose a government
                  related identifier only where permitted under APP 9, for
                  example to verify your identity, or where it is required or
                  authorised by law. Tax file numbers are also protected under
                  separate tax file number rules and are collected only where
                  the law allows.
                </p>

                <h3>11. Cookies and website analytics</h3>
                <p className="non-bold">
                  When you use our websites, we may collect general information
                  such as your IP address, geo-location, the browser and
                  operating system you use, the website you came from, the pages
                  you view and the next website you visit. We use cookies, small
                  data files placed on your device, to recognise you when you
                  return, monitor website traffic, keep our websites secure, and
                  improve your experience. This information is generally
                  aggregated and does not identify you personally.
                </p>
                <p className="non-bold">
                  You can set your browser to refuse cookies or to alert you
                  when cookies are being used. If you disable cookies, you may
                  not be able to access all parts of our websites, or some
                  features may not work properly.
                </p>

                <h3>12. Keeping your information accurate</h3>
                <p className="non-bold">
                  We take reasonable steps to ensure the personal information we
                  collect is accurate, up to date and complete, and that the
                  personal information we use or disclose is, having regard to
                  the purpose, accurate, up to date, complete and relevant.
                  Please tell us promptly if your details change, or if you
                  believe the information we hold about you is inaccurate.
                </p>

                <h3>13. How we hold and secure your information</h3>
                <p className="non-bold">
                  We hold your personal information electronically on our own
                  systems and those of our service providers. We take reasonable
                  steps, including technical and organisational measures and
                  physical, personnel and administrative controls such as access
                  restrictions and encryption of information in transit and at
                  rest, to protect your personal information from misuse,
                  interference and loss, and from unauthorised access,
                  modification or disclosure.
                </p>
                <p className="non-bold">
                  When we no longer need your personal information for any
                  purpose for which it may be used or disclosed, and we are not
                  required by law to retain it, we take reasonable steps to
                  destroy it or to ensure it is de-identified. Credit and
                  finance records are generally retained for at least seven
                  years, or longer where the law requires.
                </p>

                <h3>14. Accessing and correcting your information</h3>
                <p className="non-bold">
                  You may ask us for access to the personal information we hold
                  about you and ask us to correct it if it is inaccurate, out of
                  date, incomplete, irrelevant or misleading. To make a request,
                  contact the Oxygen Privacy Officer (see section 18) and verify
                  your identity.
                </p>
                <p className="non-bold">
                  We will respond to your request within a reasonable period and
                  aim to respond within 30 days. We will generally give you
                  access in the way you ask for, but we may decline access or
                  correction where an exception in APP 12 or APP 13 applies; if
                  we do, we will tell you why in writing and how to complain. We
                  may recover our reasonable costs of giving you access, but we
                  do not charge you to make a request or to have your
                  information corrected.
                </p>

                <h3>15. Automated decision-making</h3>
                <p className="non-bold">
                  Some steps in assessing an application for finance may involve
                  automated processing, such as automated credit scoring or
                  system checks. Where a decision that could significantly
                  affect your rights or interests is made solely or
                  substantially by an automated process, you can contact us to
                  ask about that decision and request that it be reviewed by a
                  person.
                </p>

                <h3>16. Changes to this Policy</h3>
                <p className="non-bold">
                  We may update this Policy from time to time to reflect changes
                  in our information handling practices or the law. The current
                  version is published at{" "}
                  <a href="https://oxygen.com.au/privacy">
                    oxygen.com.au/privacy
                  </a>{" "}
                  and applies from the date it is published.
                </p>

                <h3>17. Making a privacy complaint</h3>
                <p className="non-bold">
                  If you believe we have breached the APPs or the CR Code, or
                  you have a concern about how we handle your personal
                  information, please contact the Oxygen Privacy Officer in
                  writing (see section 18). Your complaint should identify you.
                  We take complaints seriously, will investigate, and will aim
                  to give you our decision in writing within 30 days of
                  receiving your complaint.
                </p>
                <p className="non-bold">
                  If you are not satisfied with our response, you can contact:
                </p>
                <ul>
                  <li>
                    the Office of the Australian Information Commissioner (OAIC)
                    — <a href="https://www.oaic.gov.au">oaic.gov.au</a>; or
                  </li>
                  <li>
                    for finance-related complaints, our external dispute
                    resolution scheme, the Australian Financial Complaints
                    Authority (AFCA) provides a free and independent dispute
                    resolution service.
                    <ul>
                      <li className="privacy-contact-info">
                        <span>Phone: 1800 931 678</span>
                      </li>
                      <li className="privacy-contact-info">
                        Email:{" "}
                        <a href="mailto:info@afca.org.au">info@afca.org.au</a>
                      </li>
                      <li className="privacy-contact-info">
                        Online:{" "}
                        <a href="https://www.afca.org.au">afca.org.au</a>
                      </li>
                    </ul>
                  </li>
                </ul>

                <h3>18. Contact us</h3>
                <p className="non-bold">
                  If you have any questions about this Policy, or you wish to
                  access or correct your personal information or make a
                  complaint, please contact the Oxygen Privacy Officer:
                </p>
                <ul>
                  <li>
                    Email:{" "}
                    <a href="mailto:oxygen@oxygen.com.au">
                      oxygen@oxygen.com.au
                    </a>
                  </li>
                  <li>
                    Telephone:
                    <span className="privacy-contact-info"> 1300 855 699</span>
                  </li>
                  <li>
                    Post:
                    <span className="privacy-contact-info">
                      {" "}
                      The Privacy Officer,
                      <br /> Oxygen Home Loans,
                      <br /> Level 7, 60 Carrington Street,
                      <br /> Sydney NSW 2000
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CTABanner />
      <Footer />
    </Layout>
  )
}

export default Privacy
